import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import i18n from "@/lang";
import '@/assets/iconfonts/iconfont.css'
import {VueMasonryPlugin} from 'vue-masonry';

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(VueMasonryPlugin)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
